import { EditTwoTone, PlusCircleTwoTone } from "@ant-design/icons"

export const addCollapseIcon = <PlusCircleTwoTone className="uif-collapse__add-icon" twoToneColor="#52c41a" />
export const editCollapseIcon = <EditTwoTone className="uif-collapse__edit-icon" />